import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import Login from './components/Login';
import DiagramViewer from './components/DiagramViewer';
import AdminPanel from './components/AdminPanel';
import InitializeAdmin from './components/InitializeAdmin';
import { onAuthChange, logout } from './services/authService';
import { getUserById } from './services/userService';
import { getRoleById } from './services/roleService';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [currentRole, setCurrentRole] = useState(null);
  const [loading, setLoading] = useState(true);

  // Aplicar tema desde localStorage al iniciar (se ejecuta siempre, sin importar la ruta)
  useEffect(() => {
    const savedTheme = localStorage.getItem('theme') || 'light';
    document.documentElement.setAttribute('data-theme', savedTheme);
  }, []);

  useEffect(() => {
    // Observar cambios en la autenticación
    const unsubscribe = onAuthChange(async (user) => {
      if (user) {
        try {
          // Obtener datos adicionales del usuario
          const userData = await getUserById(user.uid);

          if (userData && userData.isActive) {
            // Obtener rol del usuario
            const roleData = await getRoleById(userData.roleId);

            setCurrentUser({ ...user, ...userData });
            setCurrentRole(roleData);
            setIsAuthenticated(true);
          } else {
            // Usuario desactivado
            await logout();
            setIsAuthenticated(false);
            setCurrentUser(null);
            setCurrentRole(null);
          }
        } catch (error) {
          console.error('Error cargando datos del usuario:', error);
          setIsAuthenticated(false);
          setCurrentUser(null);
          setCurrentRole(null);
        }
      } else {
        setIsAuthenticated(false);
        setCurrentUser(null);
        setCurrentRole(null);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error('Error al cerrar sesión:', error);
    }
  };

  if (loading) {
    return (
      <div className="App">
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
          <div className="spinner"></div>
        </div>
      </div>
    );
  }

  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Ruta DESHABILITADA - Descomentar solo cuando se necesite inicializar un nuevo admin */}
          {/* <Route path="/init-admin" element={<InitializeAdmin />} /> */}

          {/* Rutas protegidas */}
          {!isAuthenticated ? (
            <Route path="*" element={<Login />} />
          ) : (
            <>
              <Route
                path="/docs/:diagramId"
                element={
                  <DiagramViewer
                    onLogout={handleLogout}
                    currentUser={currentUser}
                    currentRole={currentRole}
                  />
                }
              />
              <Route
                path="/docs"
                element={
                  <DiagramViewer
                    onLogout={handleLogout}
                    currentUser={currentUser}
                    currentRole={currentRole}
                  />
                }
              />
              {(currentRole?.isSuperAdmin || currentRole?.isAdmin) && (
                <Route
                  path="/admin"
                  element={
                    <AdminPanel
                      onLogout={handleLogout}
                      currentUser={currentUser}
                      currentRole={currentRole}
                    />
                  }
                />
              )}
              <Route path="/" element={<Navigate to="/docs" replace />} />
            </>
          )}
        </Routes>
      </div>
    </Router>
  );
}

export default App;
